/** 迁站接口（move_entry_site / site_master_move_entry）公共响应字段 */
export type EntryRelocateResponse = {
  ok?: boolean;
  noop?: boolean;
  entry_id?: number;
  old_entry_id?: number;
  site_id?: number;
  from_site_id?: number;
  forward_tasks_removed?: number;
  forward_tasks_created?: number;
  err?: string;
  detail?: string;
};

export function formatEntryRelocateMessage(
  r: EntryRelocateResponse,
  siteLabel?: string
): string {
  if (r.noop) {
    return '已在目标站点，无需更换';
  }
  const newId = r.entry_id;
  const oldId = r.old_entry_id;
  const dest = siteLabel?.trim() || (r.site_id ? `站点 #${r.site_id}` : '目标站点');
  let main =
    newId && oldId && newId !== oldId
      ? `已迁往「${dest}」，新信息 #${newId}（原 #${oldId} 已删除）`
      : `已更换到「${dest}」`;
  const removed = r.forward_tasks_removed ?? 0;
  const created = r.forward_tasks_created ?? 0;
  if (removed > 0 || created > 0) {
    main += `。转发任务：已移除 ${removed} 条`;
    main += created > 0 ? `，目标站已入队 ${created} 条` : '；目标站未新建队列（请确认该站已开启机器人模块）';
  }
  return main;
}
